import request from "@/utils/request";

// 获取api组
export function getGroupList(data) {
  return request({
    url: "/Sys/ApiAuthority/GetGroupList",
    method: "post",
    data: data
  });
}

// 获取api列表分页数据
export function getApiByGroupId(data) {
  return request({
    url: "/Sys/ApiAuthority/GetApiByGroupId",
    method: "post",
    data: data
  });
}

// 同步api列表数据
export function sysApi(params) {
  return request({
    url: "/Sys/ApiAuthority/SysApi",
    method: "post",
    params: params
  });
}

// 获取当前登录人所选应用菜单权限(获取用户功能权限)
export function getApiAuthories(data) {
  return request({
    url: "/ums/user/authority/function/list/".concat(data),
    method: "get",
    data: data
  });
}